import TaskFileChip from './TaskFileChip';

export default TaskFileChip;
